query GetCameraControlForRender($slug: String!, $camControlId: ID!) {
  renderState: StreamToolsGetCameraControlForRender(slug: $slug, camControlId: $camControlId)
}
